import { render } from "./BakeryAppThree.vue?vue&type=template&id=37c0158e"
import script from "./BakeryAppThree.vue?vue&type=script&lang=js"
export * from "./BakeryAppThree.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__